import styled from '@emotion/styled'

export const ModalSectionLabel = styled.p({
  color: 'black',
  fontSize: 14,
  marginTop: 20,
  marginBottom: 10,
})
